import { useContext } from "react";
import { CachedDataContext } from "@/contexts/CachedDataContext";

export const useCachedContext = () => {
  const context = useContext(CachedDataContext);
  if (!context) {
    throw new Error("useCachedContext must be used within CachedDataProvider");
  }
  return context;
};
